document.addEventListener( 'DOMContentLoaded', function () {
  const menuSearchIcon = document.querySelector( '.menu-search-icon' );
  if ( !menuSearchIcon ) return;
  const menuTitle = menuSearchIcon.querySelector( '.mega-menu-title' );
  const searchClose = menuSearchIcon.querySelector( '.search-close' );
  const searchInput = menuSearchIcon.querySelector( '.search-input' );
  // .menu-search-icon is shared with the newer walker-based nav
  // (Walker_Nav_Menu_Mega, docs/navigation-clean-rebuild.md), whose search
  // is a native popover with none of these Max Mega Menu-specific children
  // — bail rather than throw when this script is running against that markup.
  if ( !menuTitle || !searchClose || !searchInput ) return;
  const body = document.body;
  const originalPlaceholder = searchInput.getAttribute( 'data-placeholder' );
  
  
  function addActiveSearchClass() {
    const megaDescriptionGroup = menuSearchIcon.querySelector( '.mega-description-group' );
    megaDescriptionGroup.classList.add( 'active-search' );
    searchInput.focus();
    body.style.overflow = 'hidden';
  }
  
  function removeActiveSearchClass() {
    const megaDescriptionGroup = menuSearchIcon.querySelector( '.mega-description-group' );
    megaDescriptionGroup.classList.remove( 'active-search' );
    body.style.overflow = '';
  }
  
  menuTitle.addEventListener( 'click', addActiveSearchClass );
  searchClose.addEventListener( 'click', removeActiveSearchClass );
  
  const observer = new MutationObserver( function ( mutationsList ) {
    for ( const mutation of mutationsList ) {
      if ( mutation.type === 'attributes' && mutation.attributeName === 'placeholder' ) {
        const currentPlaceholder = searchInput.getAttribute( 'placeholder' );
        if ( currentPlaceholder === '' ) {
          searchInput.setAttribute( 'placeholder', originalPlaceholder );
        }
      }
    }
  } );
  
  observer.observe( searchInput, { attributes: true } );
  
  if ( searchInput.getAttribute( 'placeholder' ) === '' ) {
    searchInput.setAttribute( 'placeholder', originalPlaceholder );
  }
} );
  